module.exports = __webpack_public_path__ + "img/shop6-1.089405bd.png";